import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

//-- Keeps PunchOut buyers out of the normal checkout/order-review flow (they return their cart to
//-- the procurement system instead). Redirects to the cart if a PunchOut session is active.
const PunchOutRedirectGuard = ({ children }) => {
    const isPunchOut = useSelector((state) => state.punchoutReducer.isPunchOut);

    if (isPunchOut) {
        return <Navigate to="/cart" replace />;
    }

    return children;
};

export default PunchOutRedirectGuard;
